import React, { useEffect, useMemo } from "react";
import { Modal, Card, Button } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ThankCard = ({
  show,
  onHide,
  customerName = "Customer",
  loanType = "Loan",          
  loanCode = "LN",                      
  loanId,
  listRoute = "/",
  isLoggedIn = false,
  delay = 8000,
}) => {
  const navigate = useNavigate();

    const generateReferenceNo = (loanCode, loanId) => {
    if (!loanCode || !loanId) return "";
    const today = new Date();
    const yy = String(today.getFullYear()).slice(-2);   
    const mm = String(today.getMonth() + 1).padStart(2, "0"); 
    const dd = String(today.getDate()).padStart(2, "0");  
    return `${loanCode}${yy}${mm}${dd}${loanId}`;
  };

  const referenceNo = useMemo(() => generateReferenceNo(loanCode, loanId), [
    loanCode,
    loanId,
  ]);

  useEffect(() => {
    if (!show) return;

    const timer = setTimeout(() => {
      navigate(isLoggedIn ? listRoute : "/");
    }, delay);

    return () => clearTimeout(timer);
  }, [show, navigate, isLoggedIn, listRoute, delay]);

  const handleOk = () => {
    navigate(isLoggedIn ? listRoute : "/");
  };

  return (
    <div className="modal-overlay-edit">
      <div className="modal-content-edit thank-card-modal">
        <Card className="text-center p-4 border-0">
          <div className="d-flex justify-content-center mb-3">
             <FaCheckCircle size={70} color="#004AAD" />
          </div>
          <h4 className="fw-bold">Application Successfully Submitted</h4>
          <hr />
          <p className="text-muted" style={{ fontSize: "16px", lineHeight: "1.6" }}>
            "Dear <b>{customerName}</b>,
            thank you for applying with <b>Right Lender</b>.
            Your <b>{loanType}</b> application has been received successfully and is now under review.
            Your Reference number is <b>{referenceNo}</b>,
            Please be patient — our representative will contact you shortly with the right offer.
            For further updates, please check your registered email with us."
          </p>

          <div className="d-flex justify-content-center">
            <Button
              variant="primary"
              className="custom-next-button"
              onClick={handleOk}
            >
              OK
            </Button>
          </div>

        </Card>
      </div>
    </div>
  );
};

export default ThankCard;